import { PlaylistRepository } from "../repositories/PlaylistRepository"
import { CreatePlaylistUseCase } from "../use_cases/CreatePlaylistUseCase"

export function makeCreatePlaylist() {
  const playlistRepository = new PlaylistRepository()
  return new CreatePlaylistUseCase(playlistRepository)
}
